/**
 * LeadForge France - Analytics Tracking
 * Google Analytics 4 integration with event tracking
 */

// Initialize GA4
export const initGA4 = (measurementId) => {
  if (!measurementId || typeof window === 'undefined') return;

  // Load gtag script
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  // Initialize dataLayer
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', measurementId, {
    send_page_view: true,
  });
};

// Track page view
export const trackPageView = (path, title) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_title: title,
    });
  }
};

// Track custom event
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
  
  // Also send to backend for backup
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/event`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ event_name: eventName, event_params: params }),
    });
  } catch (e) {
    // Silently fail
  }
};

// Predefined events
export const events = {
  // CTA clicks
  CTA_CLICK: (ctaName, location) => trackEvent('cta_click', { cta_name: ctaName, location }),
  
  // Pricing interactions
  PRICING_VIEW: () => trackEvent('pricing_view'),
  PRICING_SELECT: (volume, price) => trackEvent('pricing_select', { volume, price }),
  
  // Contact form
  CONTACT_FORM_START: () => trackEvent('contact_form_start'),
  CONTACT_FORM_SUBMIT: () => trackEvent('contact_form_submit'),
  
  // Purchase flow
  PURCHASE_START: (category, location) => trackEvent('purchase_start', { category, location }),
  CHECKOUT_START: (orderId, amount) => trackEvent('checkout_start', { order_id: orderId, amount }),
  PURCHASE_COMPLETE: (orderId, amount, volume) => trackEvent('purchase_complete', { order_id: orderId, amount, volume }),
  
  // Category interactions
  CATEGORY_VIEW: (category) => trackEvent('category_view', { category }),
  CATEGORY_SELECT: (category) => trackEvent('category_select', { category }),
  
  // User actions
  REGISTER: () => trackEvent('sign_up'),
  LOGIN: () => trackEvent('login'),
};

export default {
  initGA4,
  trackPageView,
  trackEvent,
  events,
};
